// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".region-notice .toast__button-wrapper[data-v-24d62e3c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.region-notice .toast__button[data-v-24d62e3c]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding-left:0;padding-right:0}.region-notice .region-notice__save-button[data-v-24d62e3c]{display:block;margin-left:auto}", ""]);
// Exports
module.exports = exports;
